import { api } from '../../singletons';
import { boostActions, boostLabels, category } from './constants';
/**
 * Reference documents for boost reporting:
 * https://tunein.atlassian.net/wiki/spaces/~464598146/pages/3330899988/Boost+Reporting
 * https://docs.google.com/presentation/d/1XFrqklnnLDgn5HRP1vlEWrJgVgGvUT2ExOc-dnU7zvA/edit?slide=id.g28d5eef87a2_0_14#slide=id.g28d5eef87a2_0_14
 * https://tunein.atlassian.net/browse/TUNE-17037
 */
export class AppReporter {
    #previousListenId;
    // Expose boostLabels so client app can use it.
    get boostReportingLabels() {
        return boostLabels;
    }
    set previousListenId(listenId) {
        this.#previousListenId = listenId;
    }
    reportEvent(category, action, props = {}) {
        api.telemetry.reportSandbox({ category, action, props });
    }
    reportBoostButtonVisibility(label, enabled) {
        api.telemetry.reportEvent({
            event: {
                category: category.boost,
                action: enabled ? boostActions.enabled : boostActions.disabled,
                label: label,
            },
        });
    }
    reportBoostSwitch(label, optedIn) {
        const { listenId, parentGuideId, guideId } = api.reportingContext.listeningInfo || {};
        const isTooltip = label === boostLabels.tooltip;
        const previousListenIdSubstring = this.#previousListenId ? `.${this.#previousListenId}` : '';
        const reportLabel = isTooltip || !listenId ? label : `${label}${previousListenIdSubstring}.${listenId}`;
        api.telemetry.reportEvent({
            event: {
                category: category.boost,
                action: optedIn ? boostActions.optIn : boostActions.optOut,
                label: reportLabel,
            },
            params: {
                stationId: parentGuideId || guideId || '',
                ...(isTooltip && { listenId: listenId || '' }),
            },
        });
    }
    reportBoostTooltip() {
        const { listenId, parentGuideId, guideId } = api.reportingContext.listeningInfo || {};
        api.telemetry.reportEvent({
            event: {
                category: category.boost,
                action: boostActions.show,
                label: boostLabels.tooltip,
            },
            params: {
                stationId: parentGuideId || guideId || '',
                listenId: listenId || '',
            },
        });
    }
}
